import { useContext } from "react";
import "./Header.scss";
import { AppContext, AppContextInterface } from "../../../contexts/AppContext";
import translate from "@/i18n/translate";

export default function ScrollableHeader({
  displayName,
  productView
}: {
  displayName: string | null;
  productView?: "navigator" | "planning";
}): JSX.Element {
  const { institution, sysUser, breadcrumb } =
    useContext<AppContextInterface>(AppContext);
  const showHomeBreadcrum =
    breadcrumb === "home" ||
    (sysUser &&
      sysUser.roles.includes("contributor") &&
      sysUser.roles.length === 1);

  const homeUrl = showHomeBreadcrum
    ? "/insights/home"
    : "/insights/academic_office";

  const headerBody = () => {
    if (institution) {
      const { REDIRECT_URI } = runConfig;

      return (
        <section
          id="scroll-header"
          className="immersive-header header flexible-header orgIdentity-header -no-height hidden"
        >
          <div className="page-header">
            <section className="bread-crumbs -crumb">
              <a
                href={productView === "planning" ? REDIRECT_URI : homeUrl}
                id="link-0-scrolled-page-banner"
                className="link"
              >
                <span
                  className={
                    productView === "planning"
                      ? "breadcrumb-title pss-breadcrumb-title"
                      : "breadcrumb-title"
                  }
                >
                  {productView === "planning" || showHomeBreadcrum
                    ? translate("app.mainnav.home")
                    : translate("app.mainnav.academicsAndOffices")}
                </span>
              </a>
              <span className="org-name">{displayName}</span>
            </section>
          </div>
        </section>
      );
    }
  };

  return <>{headerBody()}</>;
}
